import React, { useContext, useEffect, useMemo, type PropsWithChildren } from 'react';

import type NpawPlugin from 'npaw-plugin';

type Value = { plugin: null | NpawPlugin };
const YouboraAnaliticsContext = React.createContext<Value | undefined>(undefined);

interface Props {
  plugin: null | NpawPlugin;
}

export const YouboraAnaliticsProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  plugin,
}) => {
  useEffect(() => {
    return () => {
      if (typeof plugin?.destroy === 'function') {
        plugin.destroy();
      }
    };
  }, [plugin]);
  const value = useMemo(
    () => ({
      plugin,
    }),
    [plugin],
  );
  return (
    <YouboraAnaliticsContext.Provider value={value}>{children}</YouboraAnaliticsContext.Provider>
  );
};

export const useYouboraAnalitics = () => {
  const value = useContext(YouboraAnaliticsContext);
  if (!value) throw new Error('Missing YouboraAnaliticsContext Provider');
  return value;
};
